import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux';
import { get, set } from './Crypto';

const MIGRATECOMPANIES = [
    "SVSKT", // shivshakti
    "SHVKT", // Shivshakti
    "DEZY", // Doc 32
    "TENON", // Tenon
    "AGRSTR", // Agrostar
    "AGROSTAR", // Agrostar
    "AGRO", // Agrostar
    "BIBA", //Biba
    "GNEMODE", // Geniemode
    "MIDMIC", //Midland
    "ATPZ", //Antrepriz
    "ORZN", //DirectI
    "BLKBK", //Blackbuck
    "SEED", //SeedLogic
    "Beetel", // Beetel
    "BBQN", //BarbequeNation
    "BATA1", //Bata
    "ATYATI", // Atyati
    "AGRWL", // Dragarwal
    "MBL", // Metro Brands
    "FINOB", // fino bank
    "NPHRPS", // Nephroplus
    "HLD", // Haldiram
    "TRACKON", // Trackon
    "UFOMV", // Ufo movies
    "TATAAIA", // Tata AIA
    "ECOMEXP", // Ecommerce Express
    "CIFCPL", // Chaitanya
    "ISPRVA", //  Isprava
    "CJDARCL", // Cjdarcl
    "SVMAN", // Svamaan
    "BIZONGO", // Bizongo
    "SVMHFC", // Svatantra MHFC
    "SVMFI", // Svatantra FI
    "FMLOG", // Fm Logistics
    "CIPL", //carlsberg
    "SINDHUJA", // Sindhuja
    "MIPL", // Moengage
    // "AWL", // Adani Wilmar
    // "AWLUAT", // Adani Wilmar UAT
    "COMPASS", //compass
    "STNZ", //stanza Living
]; 

function useRedirectionHook() {

    const [migration,setMigration] = useState(get('migration')?get('migration'):false);

    let tenant = useSelector(state=>state.auth.config.tenant);

    useEffect(()=>{
        if(MIGRATECOMPANIES.includes(tenant) && !window.location.href.includes('localhost') && !window.location.href.includes('sandbox')){
            setMigration(true);
            set('migration',true)
        }
        else{
            setMigration(false);
            set('migration',false)
        }
    },[tenant])

    return {migration};
}

export default useRedirectionHook